import { render } from "./SwDatePicker.vue?vue&type=template&id=19a7d784"
import script from "./SwDatePicker.vue?vue&type=script&lang=js"
export * from "./SwDatePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__